var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRendiLogoBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480.91 109.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #1d1d1b;\n        stroke-width: .22px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #6cb535;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #1d1d1b;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n        stroke-miterlimit: 22.93;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 480.91,
    height: 109.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "285.98 32.94 350.89 32.94 350.89 87.25 340.2 87.25 340.2 43.8 296.76 43.8 296.76 87.25 285.98 87.25 285.98 32.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 434.66,
    y: 32.94,
    width: 10.61,
    height: 54.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.83 87.25 137.83 32.94 202.75 32.94 202.75 43.8 148.61 43.8 148.61 87.25 137.83 87.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "360.58 32.94 414.8 32.94 414.8 11.3 425.49 11.3 425.49 87.25 360.58 87.25 360.58 32.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "212.34 32.96 277.46 32.96 277.46 44.05 223.24 44.05 223.24 55.13 277.27 55.13 277.27 65.27 223.34 65.27 223.34 76.26 277.46 76.26 277.46 87.25 212.25 87.25 212.34 32.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 371.36,
    y: 43.55,
    width: 43.44,
    height: 32.67
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRendiLogoBig);
export default __webpack_public_path__ + "static/media/rendiLogoBig.431dbaaaa7904a67a132c20a44bcaa3d.svg";
export { ForwardRef as ReactComponent };